import React from 'react';

import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { useLocation, useNavigate } from "react-router-dom";

const TablePikuahBniaList = ({ pikuahData }) => {
	const tikDataList = pikuahData;

	const search = useLocation().search;

	const titles = {
		"tikNum": "מספר תיק",
		"sugTik": "סוג התיק",
		"statusCodeText": "סטטוס",
		"taarihStatus": "תאריך סטטוס",
	}

	const navigate = useNavigate();

	const LabeledDataItem = (label, value, dataItem, field) => {
		return <div className="labeled-grid-cell">
			<div className="label">{label}</div>
			{
				dataItem !== undefined && field === "tikNum" ? 
					<div style={{ cursor: "pointer", color: "blue" }} onClick={() => openTiK(dataItem)}>
						{value}
					</div>
					: 
					<div className="value">{value}</div>
			}
		</div>
	}

	const LabeledCell = (props) => {
		return <td {...props.tdProps}>
			{LabeledDataItem(titles[props.field], props.dataItem[props.field], props.dataItem, props.field)}
		</td>
	}

	const openTiK = (tikDataItem) => {
		const systemCodeURL = new URLSearchParams(search).get("SystemCode");
		navigate(`/PikuahBniaDetails?TikNum=${tikDataItem.tikNum}&SystemCode=${systemCodeURL}&Page=ProcessInfo`);
	}

	return (
		<Grid data={tikDataList} >
			<GridColumn field="tikNum" title={titles.tikNum} cell={LabeledCell} />
			<GridColumn field="sugTik" title={titles.sugTik} cell={LabeledCell} />
			<GridColumn field="statusCodeText" title={titles.statusCodeText} cell={LabeledCell} />
			<GridColumn field="taarihStatus" title={titles.taarihStatus} cell={LabeledCell} />
		</Grid>
    )
}

export default TablePikuahBniaList